module.exports = __webpack_public_path__ + "static/media/08.ff830f24.jpg";